import { useWorkspaces } from "@api/workspace.api";
import { useOrganizationContext } from "@state/organizationContext";

export function useOrganizationWorkspaces() {
    const { activeOrganization } = useOrganizationContext();

    return useWorkspaces({
        organizationId: activeOrganization?.id,
        excludeUserOrganizations: !activeOrganization,
    });
}
